import { FC } from 'react'
import { useRouter } from 'next/router'
import NextHead from 'next/head'
import { generateUri } from '@commerce/utils/uri-util'
import { IMG_PLACEHOLDER } from '@components/utils/textVariables'

const NextHeadSEO: FC<any> = ({ seoSettings }: any) => {
  const router = useRouter()

  const seoInfo =
    seoSettings?.title || seoSettings?.description || seoSettings?.keywords
      ? seoSettings
      : undefined

  const seoImage =
    seoSettings?.title || seoSettings?.description || seoSettings?.keywords
      ? seoSettings?.products?.images?.[0]?.url
      : undefined
  return (
    <>
      <NextHead>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover"
        />

        {seoInfo && (
          <>
            <title>{seoInfo?.title}</title>
            <link
              rel="canonical"
              id="canonical"
              href={
                seoInfo?.canonicalTags ||
                'https://www.damensch.com' + router.asPath
              }
            />
            <meta name="title" content={seoInfo?.title} />
            <meta name="description" content={seoInfo?.description} />
            <meta name="keywords" content={seoInfo?.keywords} />
            <meta property="og:title" content={seoInfo?.title} key="ogtitle" />
            <meta
              property="og:description"
              content={seoInfo?.description}
              key="ogdesc"
            />
          </>
        )}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="DaMENSCH" key="ogsitename" />
        <meta
          property="og:url"
          content={'https://www.damensch.com' + router.asPath}
          key="ogurl"
        />
        <meta property="og:image" content={seoImage} />
        {seoSettings?.images?.length &&
          seoSettings?.images.map((image: any, id: number) => (
            <link
              rel="preload"
              href={
                generateUri(
                  image?.mobileUrl || image?.url,
                  'fm=webp&h=530&q=50'
                ) || IMG_PLACEHOLDER
              }
              as="image"
              key={id}
            />
          ))}
      </NextHead>
    </>
  )
}

export default NextHeadSEO
